@if (layout != null && formGroup != null) {
  <form [formGroup]="formGroup" class="transport-details-panel">
    @for (sequence of layout.sequences; track sequence; let i = $index) {
      <ng-container class="sequence">
        @if (i > 0) {
          <sc-content-spacer vertical></sc-content-spacer>
        }
        @if (sequence?.identifier != null) {
          <sc-title>{{sequence.identifier}}</sc-title>
          <sc-content-spacer vertical></sc-content-spacer>
        }
        <sc-flex [startAligned]="true">
          @for (column of sequence.columns; track column; let j = $index) {
            @if (j > 0) {
              <sc-content-spacer></sc-content-spacer>
            }
            <sc-flex-fitting-content [minSize]="250">
              @for (row of column.rows; track row; let k = $index) {
                @if (k > 0) {
                  <sc-content-spacer vertical [half]="true"></sc-content-spacer>
                }
                <div class="row no-field-space">
                  <sc-flex>
                    @for (field of row.fields; track field; let l = $index) {
                      @if (l > 0) {
                        <sc-content-spacer [half]="true"></sc-content-spacer>
                      }
                      @if (field.detail?.isEditable) {
                        <app-transport-details-field-wrapper [field]="field" [formControlName]="field.identifier"
                          [mode]="mode" [transport]="transport" (valueChange)="handleValueChange()"
                        [disableAutoComplete]="disableAutoComplete"></app-transport-details-field-wrapper>
                      }
                      @if (!field.detail?.isEditable) {
                        <app-transport-details-field-wrapper [field]="field"
                          [mode]="mode" [transport]="transport"
                        [disableAutoComplete]="disableAutoComplete"></app-transport-details-field-wrapper>
                      }
                    }
                  </sc-flex>
                </div>
              }
            </sc-flex-fitting-content>
          }
        </sc-flex>
      </ng-container>
    }
  </form>
}
@if (layout == null) {
  <sc-dictionary-label dictionaryKey="tbd-no-layout-available"></sc-dictionary-label>
}
